import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  // 全局状态存放
  state: {
  },
  mutations: {
  },
  // 数据业务逻辑
  actions: {
  },
  modules: {
  }
})
